import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Header extends Component {
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return <h2 className={finalRootClass}>{this.props.children}</h2>;
  }
}

Header.propTypes = {
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Title/index.js